import StrategyStatus from './strategy-status';

export default StrategyStatus;
